"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2415],{

/***/ 22415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Newsletter; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@hookform/error-message/dist/index.esm.js
var dist_index_esm = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/form/FieldError/FieldError.tsx



const FieldError = (param)=>{
    let { name , errors , additionalClassName  } = param;
    const className = classnames_default()("contact-form__error", additionalClassName);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* ErrorMessage */.B, {
        errors: errors,
        name: name,
        render: (param)=>/*#__PURE__*/ {
            let { message  } = param;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                className: className,
                children: message
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/form/FieldError/index.ts

/* harmony default export */ var form_FieldError = (FieldError);

;// CONCATENATED MODULE: ./components/form/Checkbox/Checkbox.tsx




const Checkbox = (param)=>{
    let { name , label , additionalClassName  } = param;
    const { register , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    const currentValue = (0,index_esm/* useWatch */.qo)({
        name
    });
    const className = classnames_default()("checkbox", additionalClassName, {
        "checkbox--error": !!(errors === null || errors === void 0 ? void 0 : errors[name])
    });
    const inputClassName = classnames_default()("checkbox__input", {
        "checkbox__input--checked": !currentValue
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
                className: "checkbox__input-container",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        id: name,
                        type: "checkbox",
                        className: inputClassName,
                        ...register(name)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "checkbox__check-mark"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                className: "checkbox__label",
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_FieldError, {
                name: name,
                errors: errors,
                additionalClassName: "contact-form__error--checkbox"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/form/Checkbox/index.ts

/* harmony default export */ var form_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/form/TextInput/TextInput.tsx




const TextInput = (param)=>{
    let { name , label , type , additionalClassName  } = param;
    var _errors_name;
    const { register , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    const currentValue = (0,index_esm/* useWatch */.qo)({
        name
    });
    const className = classnames_default()("text-input__input", {
        "text-input__input--filled": !!currentValue,
        "text-input__input--error": !!(errors === null || errors === void 0 ? void 0 : (_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message)
    }, additionalClassName);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "text-input",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                type: type,
                id: name,
                className: className,
                ...register(name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                htmlFor: name,
                className: "text-input__label",
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "text-input__line"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_FieldError, {
                name: name,
                errors: errors,
                additionalClassName: "contact-form__error--text-input"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/form/TextInput/index.ts

/* harmony default export */ var form_TextInput = (TextInput);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./styledComponents/ButtonWithGradientHover/buttonWithGradientHover.styles.tsx
var buttonWithGradientHover_styles = __webpack_require__(46572);
;// CONCATENATED MODULE: ./styledComponents/ButtonWithGradientHover/ButtonWithGradientHover.tsx


const ButtonWithGradientHover = (param)=>{
    let { children , onClick , disabled , fillButton , fit , as , ...props } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttonWithGradientHover_styles/* StyledButton */.S, {
        disabled: disabled,
        fillButton: fillButton,
        fit: fit,
        onClick: onClick,
        as: as,
        ...props,
        children: children
    });
};

;// CONCATENATED MODULE: ./styledComponents/ButtonWithGradientHover/index.ts

/* harmony default export */ var styledComponents_ButtonWithGradientHover = (ButtonWithGradientHover);

// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/Newsletter/newsletter.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 5.5rem;\n    padding-bottom: 8.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: [col1]auto [col2]auto;\n    grid-template-rows: [row1]auto [row2]auto [row3]auto [row4]auto;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n    max-width: 46.625rem;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-row: 1/2;\n    grid-column: 1/3;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 51.5rem;\n    margin-bottom: 2.5rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 37.5rem;\n    max-height: 4rem;\n    grid-column: col1;\n    grid-row: row2/row3;\n    margin: 0;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-column: col1;\n    grid-row: row4;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 18.75rem;\n    max-height: 12.0625rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 25rem;\n    min-height: 15.625rem;\n    grid-row: 1 / 4;\n    grid-column: col2;\n    justify-self: center;\n    align-self: center;\n    margin-top: 3.125rem;\n    margin-left: 1.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 18.75rem;\n      height: 12.0625rem;\n    "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 25rem;\n      height: 15.625rem;\n    "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4rem;\n    grid-column: col1/col2;\n    grid-row: row3/row4;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0.5rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 42rem;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0 auto;\n    padding: 2rem;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 35rem;\n    position: static;\n    transform: none;\n    grid-column: 2;\n    grid-row: 2 / 4;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: ",
        "px;\n      "
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: ",
        "px;\n      "
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    border: 0.0625rem solid #e3e3e3;\n    border-left: none;\n    border-top: none;\n    margin-top: 21px;\n  "
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 0.0625rem solid #e3e3e3;\n    border-right: none;\n    border-top: none;\n    right: unset;\n    margin-left: -43px;\n    margin-top: 252px;\n  "
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 3.5rem 2.25rem 5rem 2.25rem;\n  "
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 3.5rem 6.875rem 5rem 6.875rem;\n  "
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.75rem 1.5rem;\n    max-width: 16.875rem;\n    margin-bottom: 2.5rem;\n  "
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 16.875rem;\n    margin-bottom: 2.625rem;\n  "
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n  "
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.25rem;\n    line-height: 2rem;\n    margin: 0 0 2rem 0;\n  "
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n    margin: 0;\n  "
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}






const NewsletterWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";position:relative;width:100%;z-index:10;overflow-x:hidden;padding-top:4rem;padding-bottom:5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";label{color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";}");
const NewsletterInner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi1"
})(mixins/* defaultContainerSize */.sX, ";");
const NewsletterGridContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi2"
})("display:grid;grid-template-columns:1fr;grid-template-rows:repeat(5,auto);", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const NewsletterTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e10ioivi3"
})("grid-row:2/3;", Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin-top:0;margin-bottom:2rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const NewsletterAboutFirst = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e10ioivi4"
})(Typography/* ParagraphS */.fw, ";margin-top:0;grid-row:3/4;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";letter-spacing:0.0125rem;margin-bottom:2rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const NewsletterAboutSecond = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e10ioivi5"
})("margin-top:0;font-size:0.75rem;font-weight:400;line-height:0.875rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const NewsletterImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi6"
})("max-width:12.5rem;grid-row:1 / 2;margin-bottom:2.5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";svg{", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";}");
const NewsletterFormContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi7"
})(mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";");
const CheckboxContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi8"
})("display:flex;flex-direction:row;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";");
const CheckboxContainerButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e10ioivi9"
})("margin:1.375rem 0 0;padding:0;background:transparent;border:none;align-self:flex-start;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";");
const NewsletterFullAgreement = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi10"
})("position:absolute;top:50%;transform:translateY(-50%);left:0;border:0.0625rem solid #e3e3e3;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";border-radius:0.125rem;padding:1rem;z-index:40;visibility:", (param)=>{
    let { theme , isVisible  } = param;
    return isVisible ? "visible" : "hidden";
}, ";margin-right:1rem;margin-left:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject15())), ";@media (min-width:1250px){max-width:38rem;}@media (min-width:1300px){max-width:42.8125rem;}");
const Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi11"
})("display:none;position:absolute;width:1.375rem;height:1.375rem;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";transform:rotate(45deg);", (param)=>{
    let { positionX , positionXlg  } = param;
    return positionX && (0,emotion_react_browser_esm/* css */.iv)(_templateObject18(), mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject16(), positionX)), mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject17(), positionXlg)));
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject19())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject20())), ";");
const AgreementParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e10ioivi12"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;font-weight:300;line-height:1.5rem;letter-spacing:0.0125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin-top:0;&:last-child{margin-bottom:0;}> a{color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";}");
const NewsletterModalWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi13"
})("display:flex;flex-direction:column;padding:2.5rem 1.5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject21())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject22())), ";svg{margin:0 auto 2rem auto;}");
const NewsletterModalButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e10ioivi14"
})("font-size:1.125rem;line-height:2rem;text-decoration:underline;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:bold;border:none;background:transparent;padding:0;margin-bottom:0.625rem;");
const NewsletterModalOverlay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ioivi15"
})("position:absolute;top:0;left:0;width:100%;height:100%;visibility:", (param)=>{
    let { theme , isVisible  } = param;
    return isVisible ? "visible" : "hidden";
}, ";background:rgba(", theme/* THEME.colors.core_black */.C.colors.core_black, ",0.65);");
const NewsletterSubmitButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(styledComponents_ButtonWithGradientHover, {
    target: "e10ioivi16"
})("margin:0 0 1rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject23())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject24())), ";");
const NewsletterModalButtonAccept = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(NewsletterModalButton, {
    target: "e10ioivi17"
})("margin-bottom:2rem;");
const NewsletterModalTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e10ioivi18"
})("font-size:2rem;line-height:2.5rem;font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";text-align:center;margin:0 0 1rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject25())), ";");
const NewsletterModalText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e10ioivi19"
})("font-size:1rem;font-weight:300;line-height:1.5rem;letter-spacing:0.0125rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";text-align:center;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 2.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject26())), ";");
const NewsletterModalTextSecond = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(NewsletterModalText, {
    target: "e10ioivi20"
})("font-size:0.75rem;font-weight:400;line-height:0.875rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";margin:0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject27())), ";");

;// CONCATENATED MODULE: ./utils/htmlSerializers/newsletterHtmlSerializer.ts



const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const newsletterHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            props = {};
            return react.createElement(AgreementParagraph, propsWithUniqueKey(props, key), children);
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/core/Footer/interfaces.ts
var interfaces = __webpack_require__(76767);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./utils/generateNewsletterFormSchema.ts


const getErrorMessage = (errorName, errors)=>{
    try {
        return prismic_reactjs.RichText.asText(errors.find((error)=>error.name === errorName).message);
    } catch (error) {
        console.error("Could not fetch error translation for ".concat(errorName, "!"), errors);
        return "ERROR.".concat(errorName);
    }
};
const generateNewsletterFormSchema = (param)=>{
    let { email , firstname , agreement  } = param;
    return es/* object */.Ry().shape({
        firstname: es/* string */.Z_().required(getErrorMessage("required", firstname)).max(128, getErrorMessage("max", firstname)).ensure(),
        email: es/* string */.Z_().required(getErrorMessage("required", email)).email(getErrorMessage("email", email)).max(128, getErrorMessage("max", email)).lowercase().trim().ensure(),
        agreement: es/* bool */.Xg().oneOf([
            true
        ], getErrorMessage("required", agreement))
    });
};

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var lib_axios = __webpack_require__(70594);
;// CONCATENATED MODULE: ./utils/hubspot/hubspot.ts

var AgreementValue;
(function(AgreementValue) {
    AgreementValue["true"] = "Checked";
    AgreementValue["false"] = "Not Checked";
})(AgreementValue || (AgreementValue = {}));
var NDAValue;
(function(NDAValue) {
    NDAValue["true"] = "Yes";
    NDAValue["false"] = "No";
})(NDAValue || (NDAValue = {}));
const submit_hubspot_form = async (param)=>{
    let { agreement , details , email , firstname , lastname , nda  } = param;
    const portalId = "9219940";
    const formGuid = "4fabbbda-753b-4769-bb5e-d7406ac87cf1";
    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };
    const response = await axios.post("https://api.hsforms.com/submissions/v3/integration/submit/".concat(portalId, "/").concat(formGuid), {
        portalId,
        formGuid,
        fields: [
            {
                name: "firstname",
                value: firstname
            },
            {
                name: "lastname",
                value: lastname
            },
            {
                name: "email",
                value: email
            },
            {
                name: "details",
                value: details
            },
            {
                name: "agreement",
                value: AgreementValue[agreement]
            },
            {
                name: "nda",
                value: NDAValue[nda]
            }
        ],
        context: {
            pageUri: "www.qodeca.com"
        }
    }, config);
    return response;
};

;// CONCATENATED MODULE: ./utils/hubspot/hubspot_newsletter.ts


const submit_hubspot_newsletter = async (param)=>{
    let { firstname , email , agreement  } = param;
    const portalId = "9219940";
    const formGuid = "320c7505-c5df-43f6-9093-36ad37c0fd5d";
    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };
    const response = await lib_axios/* default.post */.Z.post("https://api.hsforms.com/submissions/v3/integration/submit/".concat(portalId, "/").concat(formGuid), {
        portalId,
        formGuid,
        fields: [
            {
                name: "firstname",
                value: firstname
            },
            {
                name: "email",
                value: email
            },
            {
                name: "agreement",
                value: AgreementValue[agreement]
            }
        ],
        context: {
            pageUri: "www.qodeca.com"
        }
    }, config);
    return response;
};

;// CONCATENATED MODULE: ./components/sections/Newsletter/newsletter.hooks.tsx








const useNewsletter = (dataNewsletter)=>{
    var _agreementRef_current;
    const [isAgreementShown, setIsAgreementShown] = (0,react.useState)(false);
    const [modalIsOpen, setIsModalOpen] = (0,react.useState)(false);
    const [submitted, setSubmitted] = (0,react.useState)(false);
    const [submitting, setSubmitting] = (0,react.useState)(false);
    const [result, setResult] = (0,react.useState)(interfaces/* Result.None */.x.None);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const newsletterRef = (0,react.useRef)(null);
    const agreementRef = (0,react.useRef)(null);
    const checkboxRef = (0,react.useRef)(null);
    const agreementContainerRef = (0,react.useRef)(null);
    const handleShowAgreement = (e)=>{
        e.preventDefault();
        setIsAgreementShown(true);
        if (width && width < 769) {
            var _newsletterRef_current;
            window.scrollTo({
                top: (newsletterRef === null || newsletterRef === void 0 ? void 0 : (_newsletterRef_current = newsletterRef.current) === null || _newsletterRef_current === void 0 ? void 0 : _newsletterRef_current.offsetTop) + 60,
                behavior: "smooth"
            });
        }
    };
    const handleCloseAgreement = (e)=>{
        e.preventDefault();
        setIsAgreementShown(false);
    };
    (0,react.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            var _agreementContainerRef_current, _checkboxRef_current;
            if ((agreementContainerRef === null || agreementContainerRef === void 0 ? void 0 : agreementContainerRef.current) && !(agreementContainerRef === null || agreementContainerRef === void 0 ? void 0 : (_agreementContainerRef_current = agreementContainerRef.current) === null || _agreementContainerRef_current === void 0 ? void 0 : _agreementContainerRef_current.contains(e.target)) && !(checkboxRef === null || checkboxRef === void 0 ? void 0 : (_checkboxRef_current = checkboxRef.current) === null || _checkboxRef_current === void 0 ? void 0 : _checkboxRef_current.contains(e.target))) {
                setIsAgreementShown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        agreementContainerRef
    ]);
    const schema = generateNewsletterFormSchema({
        email: dataNewsletter.errors,
        firstname: dataNewsletter.errors_firstname,
        agreement: dataNewsletter.errors_agreement
    });
    const formMethods = (0,index_esm/* useForm */.cI)({
        mode: "onTouched",
        reValidateMode: "onChange",
        resolver: (0,yup_module/* yupResolver */.X)(schema),
        defaultValues: {
            firstname: "",
            email: "",
            agreement: false
        }
    });
    const onRouteChangeComplete = ()=>{
        formMethods.reset();
        setSubmitting(false);
        setSubmitted(false);
        setResult(interfaces/* Result.None */.x.None);
    };
    (0,react.useEffect)(()=>{
        router.Router.events.on("routeChangeComplete", onRouteChangeComplete);
        return ()=>{
            router.Router.events.off("routeChangeComplete", onRouteChangeComplete);
        };
    }, []);
    const handleTryAgain = ()=>{
        formMethods.reset();
        setSubmitting(false);
        setSubmitted(false);
    };
    const handleSubmit = async (data)=>{
        setSubmitting(true);
        setResult(interfaces/* Result.None */.x.None);
        try {
            const hubspot_response = await submit_hubspot_newsletter(data);
            setSubmitting(false);
            setSubmitted(true);
            setResult(interfaces/* Result.Success */.x.Success);
            setIsModalOpen(true);
            setTimeout(()=>{
                formMethods.reset();
                setSubmitted(false);
            }, 500);
        } catch (e) {
            setSubmitting(false);
            setSubmitted(true);
            setResult(interfaces/* Result.Error */.x.Error);
            setTimeout(()=>{
                formMethods.reset();
                setSubmitted(false);
            }, 500);
        }
    };
    return {
        handleSubmit,
        formMethods,
        handleCloseAgreement,
        handleShowAgreement,
        newsletterRef,
        checkboxRef,
        submitted,
        submitting,
        width,
        isAgreementShown,
        modalIsOpen,
        setIsModalOpen,
        agreementRef,
        agreementHeight: (_agreementRef_current = agreementRef.current) === null || _agreementRef_current === void 0 ? void 0 : _agreementRef_current.clientHeight,
        agreementContainerRef
    };
};

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/Newsletter/Newsletter.tsx













const Newsletter = (param)=>{
    let { dataNewsletter  } = param;
    var _newsletterRef_current, _newsletterRef_current1, _checkboxRef_current, _newsletterRef_current2, _checkboxRef_current1;
    const { handleSubmit , formMethods , handleCloseAgreement , handleShowAgreement , newsletterRef , submitted , submitting , width , isAgreementShown , modalIsOpen , setIsModalOpen , agreementRef , agreementHeight , checkboxRef , agreementContainerRef  } = useNewsletter(dataNewsletter);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterWrapper, {
                ref: newsletterRef,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterInner, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsletterGridContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterTitle, {
                                children: prismic_reactjs.RichText.asText(dataNewsletter.title)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterAboutFirst, {
                                children: prismic_reactjs.RichText.asText(dataNewsletter.about_text)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterImage, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                    width: "200",
                                    height: "129",
                                    viewBox: "0 0 200 129",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M71.8266 1.0997C71.5144 0.963774 71.1593 0.966433 70.8492 1.10702L37.4861 16.2319H106.58L71.8266 1.0997ZM109.084 16.2319L72.2257 0.18318C71.6542 -0.0656436 71.0041 -0.0607768 70.4364 0.196575L35.0651 16.2319H15.1769C13.9601 16.2319 12.9737 17.2183 12.9737 18.4351V27.7487L0.223863 36.3286L0 36.4793L0.00312728 36.7491L1.06663 128.504L1.07236 128.999L1.56717 128.998L142.8 128.785L143.299 128.785V128.286V127.147C146.244 128.056 149.832 128.681 153.444 128.745C157.326 128.814 161.276 128.236 164.489 126.628L164.041 125.734C161.023 127.245 157.25 127.813 153.461 127.746C149.822 127.681 146.206 127.03 143.299 126.099V109.035C148.553 111.563 154.37 111.277 160.94 108.912L160.602 107.971C153.999 110.348 148.344 110.52 143.299 107.918V71.5294V67.5137C143.39 67.4682 143.503 67.4125 143.639 67.349C144.039 67.1629 144.63 66.9092 145.39 66.6447C146.911 66.1155 149.104 65.5442 151.777 65.3813C156.643 65.0849 161.477 66.0935 165.566 68.6886C169.665 71.2896 172.787 75.1808 174.441 79.7519C176.002 84.0635 176.014 88.8519 174.754 93.2863L174.091 92.4406L173.941 92.2493H173.698H156.111H155.05L155.726 93.0676L182.346 125.269L182.496 125.451H182.732H198.965H199.993L199.358 124.642L187.548 109.591C188.01 109.135 188.268 108.781 188.646 108.221C194.148 100.075 195.387 90.7656 194.143 81.4875C192.897 72.184 188.515 63.5866 181.726 57.1202C171.356 47.2447 157.622 44.4161 143.299 47.5963V35.2531V34.9652L143.05 34.8207L128.623 26.4496V18.4351C128.623 17.2183 127.637 16.2319 126.42 16.2319H109.084ZM145.062 65.7005C144.316 65.96 143.722 66.2107 143.299 66.405V48.6207C157.436 45.4223 170.898 48.1885 181.036 57.8441C187.661 64.1533 191.936 72.5421 193.153 81.6203C194.373 90.7239 193.148 99.7692 187.817 107.661C187.487 108.151 187.275 108.444 186.927 108.799L175.509 94.2486C177.023 89.448 177.103 84.1687 175.381 79.4117C173.651 74.6328 170.388 70.5643 166.102 67.8446C161.807 65.119 156.757 64.0765 151.717 64.3835C148.935 64.5529 146.652 65.1472 145.062 65.7005ZM128.623 42.9008L141.804 35.2531L128.623 27.6054V42.9008ZM142.3 36.1209L128.389 44.1924L91.0161 69.4098L142.3 126.973V71.5294V36.1209ZM141.686 127.787L90.1703 69.9631L74.9643 79.4994C73.6997 80.2925 72.0937 80.2956 70.826 79.5075L55.4693 69.9596L2.69797 127.997L141.686 127.787ZM2.05147 127.222L1.01255 37.5877L13.2242 44.202L54.6026 69.4269L2.05147 127.222ZM53.3023 67.4635L55.6398 68.8885L55.6435 68.8908L61.3863 72.4613C61.3948 72.4609 61.4034 72.4606 61.4121 72.4606L84.3064 72.4606L89.9899 68.8963L127.623 43.5029V26.7375V18.4351C127.623 17.7704 127.085 17.2315 126.42 17.2315H108.98H35.1731H15.1769C14.5122 17.2315 13.9733 17.7704 13.9733 18.4351V28.0148V43.4879L31.171 53.9719C31.1829 53.9711 31.1949 53.9707 31.207 53.9707H86.3782C86.6542 53.9707 86.878 54.1944 86.878 54.4705C86.878 54.7465 86.6542 54.9703 86.3782 54.9703H32.8087L41.0059 59.9674H97.115C97.3911 59.9674 97.6148 60.1912 97.6148 60.4672C97.6148 60.7433 97.3911 60.9671 97.115 60.9671H42.6456L51.6625 66.4639H86.3803C86.6563 66.4639 86.8801 66.6877 86.8801 66.9637C86.8801 67.2397 86.6563 67.4635 86.3803 67.4635H53.3023ZM82.7124 73.4603L62.993 73.4603L71.3538 78.6585C72.2971 79.245 73.4922 79.2427 74.4332 78.6525L82.7124 73.4603ZM12.9737 42.9295V28.9536L1.46693 36.697L12.9737 42.9295ZM157.173 93.2489L182.967 124.451H197.938L173.454 93.2489H157.173ZM27.9608 35.98C27.6847 35.98 27.4609 36.2038 27.4609 36.4798C27.4609 36.7558 27.6847 36.9796 27.9608 36.9796H97.1119C97.3879 36.9796 97.6117 36.7558 97.6117 36.4798C97.6117 36.2038 97.3879 35.98 97.1119 35.98H27.9608ZM28.4609 41.9772C28.1849 41.9772 27.9611 42.201 27.9611 42.477C27.9611 42.7531 28.1849 42.9768 28.4609 42.9768H86.3781C86.6542 42.9768 86.878 42.7531 86.878 42.477C86.878 42.201 86.6542 41.9772 86.3781 41.9772H28.4609ZM28.4609 47.9739C28.1849 47.9739 27.9611 48.1977 27.9611 48.4737C27.9611 48.7498 28.1849 48.9735 28.4609 48.9735H97.1128C97.3888 48.9735 97.6126 48.7498 97.6126 48.4737C97.6126 48.1977 97.3888 47.9739 97.1128 47.9739H28.4609Z",
                                            fill: "url(#paint0_linear)"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                                                id: "paint0_linear",
                                                x1: "22.4316",
                                                y1: "128.999",
                                                x2: "73.0618",
                                                y2: "-60.9264",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                        stopColor: "#0E4ED7"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                        offset: "0.884917",
                                                        stopColor: "#F94743"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterFormContainer, {
                                className: "newsletter__form-container",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, {
                                    ...formMethods,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                        noValidate: true,
                                        onSubmit: formMethods.handleSubmit(handleSubmit),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("fieldset", {
                                                className: "fieldset newsletter__fieldset",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_TextInput, {
                                                        additionalClassName: "newsletter__input",
                                                        name: "firstname",
                                                        label: prismic_reactjs.RichText.asText(dataNewsletter.firstname_label),
                                                        type: "text"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_TextInput, {
                                                        additionalClassName: "newsletter__input",
                                                        name: "email",
                                                        label: prismic_reactjs.RichText.asText(dataNewsletter.email_label),
                                                        type: "email"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CheckboxContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_Checkbox, {
                                                        additionalClassName: "newsletter__checkbox",
                                                        name: "agreement",
                                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                            children: [
                                                                prismic_reactjs.RichText.asText(dataNewsletter.agreement_text),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                    href: routes/* Routes.DocumentsPrivacyPolicy */.Z.DocumentsPrivacyPolicy,
                                                                    children: prismic_reactjs.RichText.asText(dataNewsletter.privacy_policy)
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxContainerButton, {
                                                        "aria-label": "Show Agreement",
                                                        onClick: (e)=>handleShowAgreement(e),
                                                        ref: checkboxRef,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                            ...(0,imageSerializer/* imageSerializer */.l)(dataNewsletter.info_button_img)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterSubmitButton, {
                                                "aria-label": "submit",
                                                type: "submit",
                                                disabled: submitting || submitted,
                                                children: prismic_reactjs.RichText.asText(dataNewsletter.button_label)
                                            })
                                        ]
                                    })
                                })
                            }),
                            width && width < 769 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalOverlay, {
                                isVisible: isAgreementShown
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsletterFullAgreement, {
                                ref: agreementContainerRef,
                                isVisible: isAgreementShown,
                                style: {
                                    top: "".concat((newsletterRef === null || newsletterRef === void 0 ? void 0 : (_newsletterRef_current = newsletterRef.current) === null || _newsletterRef_current === void 0 ? void 0 : _newsletterRef_current.clientHeight) / 2, "px"),
                                    maxHeight: "".concat(agreementHeight, "px")
                                },
                                children: [
                                    width && width >= 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        ref: agreementRef,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                                                render: dataNewsletter.agreement_text2,
                                                htmlSerializer: newsletterHtmlSerializer
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalButton, {
                                                onClick: (e)=>handleCloseAgreement(e),
                                                children: prismic_reactjs.RichText.asText(dataNewsletter.button_confirmation_label)
                                            })
                                        ]
                                    }),
                                    width && width < 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
                                        positionXlg: ((newsletterRef === null || newsletterRef === void 0 ? void 0 : (_newsletterRef_current1 = newsletterRef.current) === null || _newsletterRef_current1 === void 0 ? void 0 : _newsletterRef_current1.clientWidth) - (checkboxRef === null || checkboxRef === void 0 ? void 0 : (_checkboxRef_current = checkboxRef.current) === null || _checkboxRef_current === void 0 ? void 0 : _checkboxRef_current.offsetLeft)) / 2 - 7 - 64,
                                        positionX: ((newsletterRef === null || newsletterRef === void 0 ? void 0 : (_newsletterRef_current2 = newsletterRef.current) === null || _newsletterRef_current2 === void 0 ? void 0 : _newsletterRef_current2.clientWidth) - (checkboxRef === null || checkboxRef === void 0 ? void 0 : (_checkboxRef_current1 = checkboxRef.current) === null || _checkboxRef_current1 === void 0 ? void 0 : _checkboxRef_current1.offsetLeft)) / 2 - 7
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterAboutSecond, {
                                children: prismic_reactjs.RichText.asText(dataNewsletter.about_text2)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((lib_default()), {
                isOpen: modalIsOpen,
                ariaHideApp: false,
                preventScroll: true,
                closeTimeoutMS: 500,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsletterModalWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                            width: "81",
                            height: "54",
                            viewBox: "0 0 81 54",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M81 2.00328L27.6654 54L0 27.0286L2.05482 25.0254L27.6654 49.9935L78.9452 0L81 2.00328Z",
                                    fill: "url(#paint0_linear)"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                                        id: "paint0_linear",
                                        x1: "18.5266",
                                        y1: "120.214",
                                        x2: "116.27",
                                        y2: "58.986",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                stopColor: "#0E4ED7"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                offset: "1",
                                                stopColor: "#F94743"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalTitle, {
                            children: prismic_reactjs.RichText.asText(dataNewsletter.modal_title)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalText, {
                            children: prismic_reactjs.RichText.asText(dataNewsletter.modal_text)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalButtonAccept, {
                            onClick: ()=>setIsModalOpen(false),
                            children: prismic_reactjs.RichText.asText(dataNewsletter.button_confirmation_label)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterModalTextSecond, {
                            children: prismic_reactjs.RichText.asText(dataNewsletter.modal_text_second)
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/Newsletter/index.ts

/* harmony default export */ var sections_Newsletter = (Newsletter);


/***/ }),

/***/ 46572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ StyledButton; },
/* harmony export */   "U": function() { return /* binding */ StyledLinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n      max-width: unset;\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: fit-content;\n      max-width: unset;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}



const StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "ecegdfm0"
})("position:relative;width:100%;max-width:15.1875rem;border-radius:3.75rem;padding:0.75rem 0;color:#ffffff;text-decoration:none;background-color:#0e4ed7;transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;border:none;", (param)=>{
    let { maxWidth  } = param;
    return maxWidth && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), maxWidth);
}, ";", (param)=>{
    let { fillButton  } = param;
    return fillButton && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, ";", (param)=>{
    let { fit  } = param;
    return fit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
}, ";&:after{content:'';box-shadow:0.5rem 0.5rem 1.5rem rgba(65,70,176,0.86);opacity:0;transition:opacity 300ms ease-in-out;display:block;height:100%;width:100%;position:absolute;top:0;left:0;border-radius:4rem;z-index:0;}&:hover{&:after{opacity:1;}}&:before{content:'';width:100%;height:100%;border-radius:3.75rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);position:absolute;top:0;left:0;z-index:-1;}&:hover{background-color:transparent;}");
const StyledLinkButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
    target: "ecegdfm1"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";position:relative;width:100%;max-width:15.1875rem;border-radius:3.75rem;padding:0.75rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;", (param)=>{
    let { maxWidth  } = param;
    return maxWidth && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("max-width:", maxWidth, "px;");
}, ";", (param)=>{
    let { fillButton  } = param;
    return fillButton && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:100%;max-width:unset;");
}, ";", (param)=>{
    let { fit  } = param;
    return fit && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:fit-content;max-width:unset;");
}, ";&:after{content:'';box-shadow:0.5rem 0.5rem 1.5rem rgba(65,70,176,0.86);opacity:0;transition:opacity 300ms ease-in-out;display:block;height:100%;width:100%;position:absolute;top:0;left:0;border-radius:4rem;z-index:0;}&:hover{&:after{opacity:1;}}&:before{content:'';width:100%;height:100%;border-radius:3.75rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);position:absolute;top:0;left:0;z-index:-1;}&:hover{background-color:transparent;}");


/***/ })

}]);